import { initDb, initFunctions } from "../tools/conf";

export class TranslationProposalsController {
  subscribeToPendingProposalsCount(callback) {
    const db = initDb();
    return db
      .collection("translationProposals")
      .where("status", "==", "pending")
      .onSnapshot(
        (snapshot) => {
          if (typeof callback === "function") callback(snapshot.size || 0);
        },
        (error) => {
          console.error("[TranslationProposalsController] subscribe error:", error);
          if (typeof callback === "function") callback(0);
        }
      );
  }

  subscribeToProposals(options, callback) {
    const db = initDb();
    const { status = null, proposalType = null, languageCode = null, limit = 500 } = options || {};
    let query = db.collection("translationProposals");
    if (status) query = query.where("status", "==", status);
    if (proposalType) query = query.where("proposalType", "==", proposalType);
    if (languageCode) query = query.where("languageCode", "==", languageCode);
    return query
      .orderBy("submittedAt", "desc")
      .limit(limit)
      .onSnapshot(
        (snapshot) => {
          const list = [];
          snapshot.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
          if (typeof callback === "function") callback(list);
        },
        (error) => {
          console.error("[TranslationProposalsController] subscribeToProposals error:", error);
          if (typeof callback === "function") callback([]);
        }
      );
  }

  /**
   * Propositions d'une campagne donnée, pour afficher l'état (en attente /
   * validée / rejetée) champ par champ dans le visualiseur d'assets.
   * Pas d'orderBy volontairement : `campaignId` seul évite un index composite,
   * le tri par date se fait côté client.
   */
  subscribeToCampaignProposals(campaignId, callback) {
    const db = initDb();
    return db
      .collection("translationProposals")
      .where("campaignId", "==", campaignId)
      .onSnapshot(
        (snapshot) => {
          const list = [];
          snapshot.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
          if (typeof callback === "function") callback(list);
        },
        (error) => {
          console.error("[TranslationProposalsController] subscribeToCampaignProposals error:", error);
          if (typeof callback === "function") callback([]);
        }
      );
  }

  async reviewProposal(proposalId, decision, reviewerNote = null) {
    try {
      const cloud = await initFunctions();
      const callable = cloud.httpsCallable("reviewTranslationProposal");
      const res = await callable({ proposalId, decision, reviewerNote });
      return res.data;
    } catch (error) {
      console.error("[TranslationProposalsController] reviewProposal error:", error);
      return { success: false, error: error?.message || String(error) };
    }
  }

  async deleteProposal(proposalId) {
    try {
      const cloud = await initFunctions();
      const callable = cloud.httpsCallable("deleteTranslationProposal");
      const res = await callable({ proposalId });
      return res.data;
    } catch (error) {
      console.error("[TranslationProposalsController] deleteProposal error:", error);
      return { success: false, error: error?.message || String(error) };
    }
  }
}

export const translationProposalsController = new TranslationProposalsController();
